import React, { useState } from 'react';
import { Container, Row, Col, Offcanvas } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const AdminLayout = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="admin-layout">
      <Header onToggleSidebar={() => setShowSidebar(!showSidebar)} />
      
      <Container fluid>
        <Row>
          {/* Sidebar for larger screens */}
          <Col md={3} lg={2} className="d-none d-md-block sidebar-col">
            <Sidebar />
          </Col>
          
          {/* Offcanvas sidebar for mobile */}
          <Offcanvas
            show={showSidebar}
            onHide={() => setShowSidebar(false)}
            responsive="md"
            placement="start"
            className="d-md-none"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Admin Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Sidebar />
            </Offcanvas.Body>
          </Offcanvas>
          
          {/* Main content */}
          <Col md={9} lg={10} className="main-content">
            <Outlet />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminLayout;